<template>
  <div class="min-h-screen bg-gradient-to-br from-zinc-50 to-zinc-100 flex items-center justify-center px-4 py-12">
    <div class="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">

      <!-- Icon -->
      <div class="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg class="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
      </div>

      <h1 class="text-2xl font-bold text-gray-900 mb-2">Paiement Annulé</h1>
      <p class="text-gray-600 mb-6">Vous avez annulé le processus de paiement. Votre réservation n'a pas été confirmée.</p>

      <div class="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6">
        <p class="text-sm text-amber-800">
          <strong>Que s'est-il passé ?</strong><br/>
          Vous avez quitté la page de paiement avant de finaliser votre transaction. Aucun montant n'a été débité.
        </p>
      </div>

      <div class="space-y-3">
        <p class="text-sm text-gray-600 mb-4">Vous pouvez retourner à la page du salon pour refaire une réservation.</p>

        <div class="flex flex-col gap-3">
          <button
            @click="goToSearch"
            class="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors"
          >
            Rechercher un salon
          </button>
          <button
            @click="goHome"
            class="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-xl transition-colors"
          >
            Retour à l'accueil
          </button>
        </div>
      </div>

      <!-- Additional help section -->
      <div class="mt-8 pt-6 border-t border-gray-200">
        <p class="text-xs text-gray-500">
          Besoin d'aide ? Contactez-nous à
          <a href="mailto:support@bookmysalon.fr" class="text-amber-600 hover:underline">support@bookmysalon.fr</a>
        </p>
      </div>

    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goToSearch = () => {
  router.push('/search')
}

const goHome = () => {
  router.push('/')
}
</script>

<style scoped>
/* Styles déjà gérés par Tailwind */
</style>
